import * as React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import {
  ModalSize,
  DispatchProps,
} from './types'
import { setHideModal } from '@App/store/modal'
import HeaderModal from '@App/components/blocks/Modal/Header'

import './style.scss'

class Modal extends React.Component<any> {
  constructor(props: any) {
    super(props)

    this.state = {}

    this.onClose = this.onClose.bind(this)
    this.setModalSize = this.setModalSize.bind(this)
  }

  onClose() {
    const { setHideModal, handleClose, multiple } = this.props
    setHideModal(multiple)

    if (handleClose) {
      handleClose()
    }
  }

  setModalSize() {
    const { size } = this.props

    if (size === ModalSize.LARGE) return 'modal__large'
    if (size === ModalSize.FIT) return 'modal__fit'
    return
  }

  render() {
    const {
      children,
      type,
      modalType,
      previewDocument,
      onDownload,
      invoiceData,
      onPrint,
      isInvoice,
      onRefreshInvoice,
      disable,
      multiple,
    } = this.props

    const isOpen: boolean = multiple || type === modalType

    if (isOpen) {
      return (
        <div className={classnames('modalWrapper fixed', isOpen ? 'is-open' : 'is-hidden')}>
          <div
            className={classnames('modal', this.setModalSize(), previewDocument && 'modal--preview')}
          >
            <HeaderModal
              onClose={this.onClose}
              previewHeader={previewDocument}
              onDownload={onDownload}
              onPrint={onPrint}
              onRefreshInvoice={onRefreshInvoice}
              data={invoiceData}
              isInvoice={isInvoice}
              disable={disable}
              type={type}
            />
            {isOpen && children}
          </div>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = (states: any) => {
  const { modal } = states

  return {
    multiple: modal.multiple,
    modalType: modal.type,
    disable: modal.disable,
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
    setHideModal: isMultiple => dispatch(setHideModal(isMultiple)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal)
